export const ACCEPTED_PRACTICE_PROGRAM = 'ACCEPTED_PRACTICE_PROGRAM';
export const INITIALIZE_USER = 'INITIALIZE_USER';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const LINK_PRACTICE = 'LINK_PRACTICE';
export const LOADED_CONNECTED_PRACTICES = 'LOADED_CONNECTED_PRACTICES';
export const LOGOUT = 'LOGOUT';
export const QUICK_SHARE_SET = 'QUICK_SHARE_SET';
export const QUICK_SHARE_STOP = 'QUICK_SHARE_STOP';
export const REMOVE_SHARECODE = 'REMOVE_SHARECODE';
export const REMOVE_YEAR_OF_BIRTH = 'REMOVE_YEAR_OF_BIRTH';
export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';
export const SET_SHARECODE = 'SET_SHARECODE';
export const SET_YEAR_OF_BIRTH = 'SET_YEAR_OF_BIRTH';
export const UNLINK_PRACTICE = 'UNLINK_PRACTICE';

export interface UserState extends User {
  code: string;
  phoneLanguage: string;
  practices: PracticeMap;
  programs: ProgramMap;
  quickShare: QuickShare;
  yearOfBirth: number;
}

interface AcceptedPracticeProgramAction {
  type: typeof ACCEPTED_PRACTICE_PROGRAM;
  practice: Practice;
  programId: string;
}

interface InitializeUserAction {
  type: typeof INITIALIZE_USER;
  user: Partial<UserState>;
}

interface LanguageChangeAction {
  type: typeof LANGUAGE_CHANGE;
  language: string;
}

interface LinkPracticeAction {
  type: typeof LINK_PRACTICE;
  practice: Practice;
}

interface LoadedConnectedPracticesAction {
  type: typeof LOADED_CONNECTED_PRACTICES;
  practices: PracticeMap;
}

interface RemoveShareCodeAction {
  type: typeof REMOVE_SHARECODE;
  code: string;
}

interface RemoveYearOfBirthAction {
  type: typeof REMOVE_YEAR_OF_BIRTH;
  yearOfBirth: number;
}

interface SetPhoneLanguageAction {
  type: typeof SET_PHONE_LANGUAGE;
  language: string;
}

interface SetShareCodeAction {
  type: typeof SET_SHARECODE;
  code: string;
}

interface SetYearOfBirthAction {
  type: typeof SET_YEAR_OF_BIRTH;
  yearOfBirth: number;
}

interface StopQuickShareAction {
  type: typeof QUICK_SHARE_STOP;
  code: string;
}

interface SetQuickShareAction {
  type: typeof QUICK_SHARE_SET;
  quickShare: QuickShare;
}

interface UnlinkPracticeAction {
  type: typeof UNLINK_PRACTICE;
  practiceId: string;
}

interface UserLogoutAction {
  type: typeof LOGOUT;
}

export type UserActions =
  | AcceptedPracticeProgramAction
  | InitializeUserAction
  | LanguageChangeAction
  | LinkPracticeAction
  | LoadedConnectedPracticesAction
  | RemoveShareCodeAction
  | SetPhoneLanguageAction
  | StopQuickShareAction
  | SetQuickShareAction
  | SetShareCodeAction
  | SetYearOfBirthAction
  | RemoveYearOfBirthAction
  | UnlinkPracticeAction
  | UserLogoutAction;
